const normalizeStatusLabel = (label) => {
  if (!label) return "";
  return String(label).trim().toLowerCase().replace(/[-_]/g, " ");
};

export const getStatusChartColor = (label, theme) => {
  const normalized = normalizeStatusLabel(label);
  if (normalized === "completed") return theme.palette.primary.main;
  if (normalized === "confirmed") return theme.palette.info.main;
  if (normalized === "delivered") return theme.palette.info.main;
  if (normalized === "in progress") return theme.palette.warning.main;
  if (normalized === "requested") return theme.palette.error.main;
  if (normalized === "cancelled" || normalized === "canceled") return theme.palette.grey[500];
  return null;
};
